import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Colors, FontSize, Spacing } from '../../../assets/GlobalStyle/Variables';

type CheckboxProps = {
  id: string;
  name: string;
  label: string;
  disabled?: boolean;
};

export const Checkbox: FC<CheckboxProps> = (props) => {
  const { id, name, label, disabled = false } = props;
  const methods = useFormContext();

  return (
    <StyledCheckboxWrapper>
      <StyledCheckbox type="checkbox" id={id} disabled={disabled} {...methods.register(name)} />
      <StyledLabel htmlFor={id}>{label}</StyledLabel>
    </StyledCheckboxWrapper>
  );
};

const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`;

const StyledCheckbox = styled.input`
  margin-right: ${Spacing(4)};
  cursor: pointer;
  width: 18px;
  height: 18px;

  &:disabled {
    cursor: not-allowed;
  }
`;

const StyledLabel = styled.label`
  color: ${Colors.grey};
  font-size: ${FontSize.normal};
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
`;
